import { Link } from "react-router-dom";
import { LuPhone, LuMail, LuMapPin } from "react-icons/lu";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="border-y border-default-200 py-8 mt-12">
          <div className="container mx-auto grid grid-cols-1 gap-6 text-center  sm:grid-cols-3 sm:text-left">
            <div className="flex flex-col items-center text-center">
              <h3 className="xl:text-xl lg:text-lg font-medium text-default-800 mb-2">
                <strong>დამატებითი ბმულები</strong>
              </h3>
              <ul className="flex flex-col gap-3">
                <li>
                  <Link
                    to="/faq"
                    className="text-base text-default-700 hover:text-default-950 transition-all"
                  >
                    ხშირად დასმული შეკითხვები
                  </Link>
                </li>
                <li>
                  <Link
                    to="/ask-contract"
                    className="text-base text-default-700 hover:text-default-950 transition-all"
                  >
                    მოითხოვე ხელშეკრულება
                  </Link>
                </li>
                <li>
                  <Link
                    to="/tracking"
                    className="text-base text-default-700 hover:text-default-950 transition-all"
                  >
                    გზავნილის ძიება
                  </Link>
                </li>
                <li>
                  <Link
                    to="/delivery-request"
                    className="text-base text-default-700 hover:text-default-950 transition-all"
                  >
                    გამოძახება
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col items-center text-center">
              <h3 className="xl:text-xl lg:text-lg font-medium text-default-800 mb-2">
                <strong>სამუშაო საათები</strong>
              </h3>
              <ul className="flex flex-col gap-3">
                <li>
                  <p className="text-base text-default-700 hover:text-default-950 transition-all">
                    ორშაბათი - პარასკევი
                  </p>
                </li>
                <li>
                  <p className="text-base text-default-700 hover:text-default-950 transition-all">
                    09:30 - 18:30
                  </p>
                </li>
                <li>
                  <p className="text-base text-default-700 hover:text-default-950 transition-all">
                    შაბათი
                  </p>
                </li>
                <li>
                  <p className="text-base text-default-700 hover:text-default-950 transition-all">
                    10:00 - 14:00
                  </p>
                </li>
              </ul>
            </div>
            <div className="flex flex-col items-center text-center">
              <h3 className="xl:text-xl lg:text-lg font-medium text-default-800 mb-2">
                <strong>კონტაქტი</strong>
              </h3>
              <ul className="flex flex-col gap-3">
                <li>
                  <p className="text-base text-default-700 hover:text-default-950 transition-all">
                    <LuMapPin className="inline-block" /> წერეთლის გამზირი #105
                  </p>
                </li>
                <li>
                  <p className="text-base text-default-700 hover:text-default-950 transition-all">
                    <LuPhone className="inline-block" /> 032 2 67 60 60
                  </p>
                </li>
                <li>
                  <p className="text-base text-default-700 hover:text-default-950 transition-all">
                    <LuMail className="inline-block" /> info@geoexpress.ge
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="py-4">
          <div className="container flex h-full flex-wrap items-center justify-center text-center md:justify-between md:text-start">
            <p className="text-base text-default-900">
              © 2020 ჯორჯიან ექსპრესი | ყველა უფლება დაცულია&nbsp;
              {/* <span className="text-red-500">❤️</span> by&nbsp; */}
              {/* <Link
                className="text-primary-700"
                to="https://coderthemes.com/"
                target="_blank"
              >
                Coderthemes
              </Link> */}
            </p>
            <p className="text-base">
              <Link to="/terms">წესები &amp; პირობები</Link>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
